import { useQuery } from "@tanstack/react-query";
import {
  fetchGetMe,
  fetchGetMeID,
  fetchGetMeStudentTeacherID,
  fetchUserBar,
  fetchUserMonthlyAttendance,
  fetchUsers,
  fetchUserSchedule,
} from "../../services/users-service";
import { UserBarType } from "types/types";

export const useFetchUsers = () => {
  return useQuery({
    queryKey: ["users"],
    queryFn: fetchUsers,
  });
};

export const useFetchGetMe = (p0?: { enabled?: boolean }) => {
  const enabled = p0?.enabled ?? true;
  return useQuery({
    queryKey: ["userItem"],
    queryFn: fetchGetMe,
    enabled,
  });
};

export const useFetchItemUser = (id: number) => {
  return useQuery({
    queryKey: ["userItemEdit"],
    queryFn: () => fetchGetMeID(id),
    enabled: id > 0,
  });
};
export const useFetchItemUserTeacher = (type: string, id: number) => {
  return useQuery({
    queryKey: ["userItemEdit"],
    queryFn: () => fetchGetMeStudentTeacherID(type, id),
    enabled: id > 0,
  });
};

export function useGetUserBar({
  user_id,
  role,
  start_date,
  end_date,
}: UserBarType) {
  return useQuery({
    queryKey: ["userBar", user_id, role, start_date, end_date],
    queryFn: () => fetchUserBar({ user_id, role, start_date, end_date }),
  });
}
export function useGetMonthlyAttendance({
  user_id,
  start_date,
  end_date,
  role,
}: UserBarType) {
  return useQuery({
    queryKey: ["userMonthlyAttendance", user_id, start_date, role],
    queryFn: () =>
      fetchUserMonthlyAttendance({ user_id, role, start_date, end_date }),
  });
}

export function useGetUserSchedule({ user_id, role }: UserBarType) {
  return useQuery({
    queryKey: ["userSchedulehistory", user_id, role],
    queryFn: () => fetchUserSchedule({ user_id, role }),
  });
}
